<template>
  <el-dialog
    v-bind="$attrs"
    v-on="$listeners"
    :close-on-click-modal="false"
    :before-close="handleClose"
    :title="$t('luck-history.抽奖记录')"
    width="454px"
    class="dialog-dark dialog-include-table"
    custom-class="historyVisible"
    @open="showHistory"
  >
    <div v-for="(item, index) in winnerHisList" :key="index">
      <p class="title">
        <span>{{ item.title }}（{{ item.winners.length }}人）</span>
        <span v-if="item.resultIssuedStatus === 1" class="unSend">{{$t('luck-history.未下发')}}</span>
      </p>
      <el-table :data="item.winners" class="table-dark table-noborder">
        <el-table-column prop="nickname" :label="$t('luck-history.姓名')" width="180px">
        </el-table-column>
        <el-table-column prop="winnerCode" :label="$t('luck-history.中奖码')"> </el-table-column>
      </el-table>
    </div>
    <div v-if="!winnerHisList.length" class="blank-wrapper">
      <Blank :text="$t('luck-history.暂无抽奖记录')" :sub-text="$t('luck-history.仅显示开启直播后的抽奖结果')" />
    </div>
  </el-dialog>
</template>
<script>
import { getWinnerHistory } from "@/api/liveRequest/luckDawApi";
import { Dialog, Table, TableColumn } from "element-ui";
import Blank from "@/components/blank";
export default {
  name: "LuckHistory",
  components: {
    [Dialog.name]: Dialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Blank,
  },
  data() {
    return {
      winnerHisList: [],
    };
  },
  methods: {
    // 点击抽奖历史
    async showHistory() {
      const { data } = await getWinnerHistory();
      this.winnerHisList = data;
    },
    // 抽奖历史弹窗关闭
    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.historyVisible {
  overflow: hidden;
  .el-dialog__body {
    padding: 0px 20px;
    max-height: 315px;
    overflow: auto;
    .title {
      color: #ff4d5b;
      margin-top: 18px;
      font-size: 18px;
      font-weight: 500;
      line-height: 25px;
      text-align: center;
    }
    .historyItem {
      color: #3b3b3b;
      span {
        display: inline-block;
        width: 50%;
        line-height: 24px;
      }
    }
    .listTitle {
      border-bottom: 1px solid #999;
      margin-top: 10px;
      font-weight: bold;
      padding-bottom: 5px;
    }
  }
}

.noneList {
  img {
    width: 160px;
    display: block;
    margin: 10px auto 40px;
  }
  p {
    font-size: 14px;
    color: #fff;
    text-align: center;
  }
  p:nth-child(3) {
    margin-top: 12px;
    color: #acb2bf;
    font-size: 12px;
  }
}
.table-dark {
  margin-top: 14px;
}
::v-deep {
  .el-dialog {
    overflow: hidden;
  }
  .el-dialog__body {
    position: relative;
    max-height: 272px;
    min-height: 272px;
    overflow: auto;
  }
  .el-table .el-table__cell {
    padding: 5px 0;
  }
}

.blank-wrapper {
  position: absolute;
  top: -48px;
  bottom: 0;
  width: 100%;
}
.unSend {
  display: inline-block;
  width: 42px;
  height: 20px;
  line-height: 18px;
  border: 1px solid #ACB2BF;
  font-size: 12px;
  color: #ACB2BF;
  text-align: center;
  vertical-align: middle;
  border-radius: 2px;
  box-sizing: border-box;
}
</style>
